import React, { useLayoutEffect } from 'react'
import { useParallaxController, Parallax } from 'react-scroll-parallax'
import useWindowDimensions from '../../hooks/useWindowDimensions'


const ParallaxSafe = ({ yto, yfrom, children }) => {
    const parallaxController = useParallaxController()
    const { height, width } = useWindowDimensions()
    useLayoutEffect(() => {
        const handler = () => parallaxController.update()
        window.addEventListener('load', handler)
    }, [parallaxController])

    const isSSR = typeof window === "undefined"

    const imageLoad = () => parallaxController.update()

    return <Parallax disabled={width <= 769} translateY={[`${yto}px`, `${yfrom}px`]} tagOuter="figure" >{children({ imageLoad: imageLoad })}</Parallax>

}

export default ParallaxSafe